module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goBackToPreviousPage":"Go back to previous page","groupQualificationStatus":"{0} - Qualifications status"},"fr":{"goBackToPreviousPage":"Retour à la page précédente","groupQualificationStatus":"{0} - Etat des qualifications"}}')
  delete Component.options._Ctor
}
